<template>
  <div class="skin-character-cell" v-if="skin">
    <v-avatar size="32" class="skin-avatar">
      <v-img :src="skin.imageUrl" :alt="skin.name" />
    </v-avatar>
    <span class="skin-name">{{ skin.name }}</span>
  </div>
  <span v-else class="skin-empty">—</span>
</template>

<script>
export default {
  name: 'SkinCharacterCell',
  props: {
    skin: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.skin-character-cell {
  display: flex;
  align-items: center;
  gap: 10px;

  .skin-avatar {
    border: 1px solid var(--v-mediumGray-base, #ddd);
    flex-shrink: 0;
  }

  .skin-name {
    font-size: 14px;
    font-weight: 500;
    color: var(--v-mainBlack-base, #1b1b1b);
    line-height: 1.2;
  }
}

.skin-empty {
  color: #9a9a9a;
  font-size: 14px;
}
</style>
